<template>
    <div class="page_hx_core flex-col">
        <div class="group_10 flex-row">
            <div class="section_9 flex-col">
                <span class="text_27">协助应对企业面临的普遍问题</span>
                <span class="text_28">SOLVE&nbsp;THE&nbsp;CORE&nbsp;PAIN&nbsp;POINTS</span>
                <div class="content_center">
                    <div class="list_10 flex-row">
                        <div class="list-items_1 flex-col" v-for="(item, index) in loopData1" :key="index">
                            <img
                                    v-if="item.slot1 === 1"
                                    class="image_10"
                                    referrerpolicy="no-referrer"
                                    :src="item.specialSlot1.lanhuimage0"
                            />
                            <img
                                    v-if="item.slot2 === 2"
                                    class="label_5"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/advisory/advisory_solve_icon_01.png"
                            />
                            <span class="text_29" v-html="item.lanhutext0"></span>

                            <div class="hover-mask">
                                <div class="hover-content">
                                    <div class="problem-section">
                                        <div class="box_16 flex-col">
                                            <div class="icon-wrapper flex-row justify-between">
                                                <img
                                                        class="thumbnail_2"
                                                        referrerpolicy="no-referrer"
                                                        src="../../../assets/advisory/advisory_problem_icon.png"
                                                />
                                                <span class="text-group_8">{{ item.problem.title }}</span>
                                            </div>
                                            <span class="text_38">{{ item.problem.value }}</span>
                                        </div>
                                    </div>
                                    <div class="solution-section">
                                        <div class="box_16 flex-col">
                                            <div class="icon-wrapper  flex-row justify-between">
                                                <img
                                                        class="thumbnail_2"
                                                        referrerpolicy="no-referrer"
                                                        src="../../../assets/advisory/advisory_solve_icon.png"
                                                />
                                                <span class="text-group_8">{{ item.solve.title }}</span>
                                            </div>
                                            <span class="text_38">{{ item.solve.value }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="content_center">
                    <div class="list_11 flex-row">
                        <div class="list-items_1 flex-col" v-for="(item, index) in loopData2" :key="index">
                            <img
                                    v-if="item.slot1 === 1"
                                    class="image_10"
                                    referrerpolicy="no-referrer"
                                    :src="item.specialSlot1.lanhuimage0"
                            />
                            <img
                                    v-if="item.slot2 === 2"
                                    class="label_5"
                                    referrerpolicy="no-referrer"
                                    src="../../../assets/advisory/advisory_solve_icon_01.png"
                            />
                            <span class="text_29" v-html="item.lanhutext0"></span>

                            <div class="hover-mask">
                                <div class="hover-content">
                                    <div class="problem-section">
                                        <div class="box_16 flex-col">
                                            <div class="icon-wrapper flex-row justify-between">
                                                <img
                                                        class="thumbnail_2"
                                                        referrerpolicy="no-referrer"
                                                        src="../../../assets/advisory/advisory_problem_icon.png"
                                                />
                                                <span class="text-group_8">{{ item.problem.title }}</span>
                                            </div>
                                            <span class="text_38">{{ item.problem.value }}</span>
                                        </div>
                                    </div>
                                    <div class="solution-section">
                                        <div class="box_16 flex-col">
                                            <div class="icon-wrapper  flex-row justify-between">
                                                <img
                                                        class="thumbnail_2"
                                                        referrerpolicy="no-referrer"
                                                        src="../../../assets/advisory/advisory_solve_icon.png"
                                                />
                                                <span class="text-group_8">{{ item.solve.title }}</span>
                                            </div>
                                            <span class="text_38">{{ item.solve.value }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                loopData1: [
                    {
                        lanhutext0: '战略决策盲区',
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve3_icon_01.png'),
                        },
                        problem: {title:'痛点',value:'应对市场变化响应滞后'},
                        solve:{title:'解决方案',value:'行业数据库+竞争对标分析，缩短决策链路，降低试错成本'},
                        slot1: 1
                    },
                    {
                        lanhutext0: '跨部门协同低效',
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve3_icon_02.png'),
                        },
                        problem: {title:'痛点',value:'部门目标冲突导致内耗'},
                        solve:{title:'解决方案',value:'建立“风险共担-利益共享”机制，优化组织协作效率'},
                        slot1: 1
                    },
                    { lanhutext0: '营销收益率低'
                        ,slot1: 1,
                        specialSlot1: {
                            lanhuimage0:require('../../../assets/advisory/advisory_solve3_icon_03.png'),
                        },
                        problem: {title:'痛点',value:'营销费用虚高、资源错配导致ROI低迷'},
                        solve:{title:'解决方案',value:'全链路诊断优化资源分配，助力优化营销效能提升RO'},
                    },

                ],
                loopData2: [

                    {
                        lanhutext0: '数据价值未释放',
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve3_icon_04.png'),
                        },
                        problem: {title:'痛点',value:'海量业务数据沉睡'},
                        solve:{title:'解决方案',value:'AI建模挖掘销售异常、供应链断点等隐患，转化数据为决策资产'},
                        slot1: 1
                    },
                    { lanhutext0: '合规转型阵痛',
                        slot1: 1 ,
                        specialSlot1: {
                            lanhuimage0: require('../../../assets/advisory/advisory_solve3_icon_05.png'),
                        },
                        problem: {title:'痛点',value:'传统模式难适应新规'},
                        solve:{title:'解决方案',value:'提供“制度重塑+数字化工具+人员培训”三位一体转型解决方案'},
                    },

                ],
            };
        },
        methods: {}
    };
</script>
<style scoped lang="css" >
    .page_hx_core {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .group_10 {
        width: 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .section_9 {
        background-color: rgba(255, 255, 255, 1);
        width: 100%;
    }

    .text_27 {
        width: 100%;
        height: 53px;
        overflow-wrap: break-word;
        color: rgba(18, 20, 28, 1);
        font-size: 38px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 53px;
        margin: 48px 0 0 0;
    }

    .text_28 {
        width: 100%;
        height: 37px;
        overflow-wrap: break-word;
        color: rgba(135, 135, 135, 1);
        font-size: 26px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 37px;
        margin-bottom: 20px;
    }

    .content_center {
        display: flex;
        justify-content: center;
        width: 100%;
    }
    .list_10 {
        height: 225px;
        margin: 40px auto 56px; /* 上下边距保持不变，左右自动居中 */
        justify-content: center; /* 将space-between改为center */
        gap: 26px; /* 用gap替代原来的margin-right */
        width: fit-content; /* 让宽度根据内容自适应 */
    }
    .list_11 {
        width: 670px;
        height: 225px;

        margin: 40px 0 56px;   /* 去掉原有的左侧 135px 边距 */
        justify-content: center;/* 子元素水平居中 */
        gap: 26px;             /* 保持原有的间隔 */
        flex-wrap: wrap;       /* 允许换行（针对小屏幕） */
    }
    /*
    .list_10:first-of-type {
        margin: 40px 0 80px 135px;
    }

    .list_10:last-of-type {
        margin: 0 0 56px 135px;
    }
    */

    .list-items_1 {
        border-radius: 10px;
        position: relative;
        width: 280px;
        height: 225px;
        border: 1px solid rgba(230, 230, 230, 1);
        margin-right: 26px;
        overflow: hidden;
        align-items: center;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }
    /****/
    .hover-mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(229, 242, 242, 1);
        border-radius: 10px;
        opacity: 0;
        transform: translateY(100%); /* 初始位置在下方 */
        transition: all 0.3s linear; /* 添加线性动画 */
        padding: 20px;
        box-sizing: border-box;
    }

    .list-items_1:hover .hover-mask {
        opacity: 1;

        transform: translateY(0);
    }

    .hover-content {
        color: white;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .problem-section {
        display: flex;
        align-items: flex-start;
        gap: 5px;

        margin-top: -5px;
    }
    .solution-section {
        display: flex;
        align-items: flex-start;
        gap: 5px;

        margin-top: -25px;
    }


    .icon-wrapper {
        width: 59px;
        height: 22px;
        margin: 5px 0 0 10px;
    }
    .thumbnail_2 {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-right: 8px;
    }
    .text-group_8 {
        width: 32px;
        height: 22px;
        overflow-wrap: break-word;
        color: rgba(0, 106, 112, 1);
        font-size: 16px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 22px;
    }
    .text_38 {
        width: 208px;
        height: 75px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 18px;
        font-weight: NaN;
        text-align: left;
        line-height: 25px;
        margin: 2px 0 0 35px;
    }

    .text-wrapper p {
        font-size: 14px;
        line-height: 1.5;
        margin: 0;
        color: #FFFFFF;
    }

    .solution-section .text-wrapper h3 {
        color: #4CAF50;
    }

    /* 调整原有元素在hover时的显示 */
    .list-items_1:hover .image_10,
    .list-items_1:hover .label_5,
    .list-items_1:hover .text_29 {
        opacity: 0;
        transition: opacity 0.3s linear;
    }

    /**end**/
    .image_10 {
        position: absolute;
        left: 115px;
        top: 65px;
        width: 50px;
        height: 50px;
    }

    .label_5 {
        position: absolute;
        left: 125px;
        top: 68px;
        width: 31px;
        height: 44px;
    }

    .text_29 {
        width: 150px;
        height: 30px;
        overflow-wrap: break-word;
        color: rgba(37, 37, 37, 1);
        font-size: 22px;
        font-weight: NaN;
        text-align: center;
        white-space: nowrap;
        line-height: 30px;
        margin: 139px 0 0 0;
    }


</style>
